/**
 * @generated SignedSource<<17c37104453d27959493449bedc515f0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { DateTime } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type PaperDetailFragment$data = {
  readonly absUrl: string | null | undefined;
  readonly abstract: string;
  readonly announcedOn: any;
  readonly arxivId: string | null | undefined;
  readonly authors: ReadonlyArray<string>;
  readonly categories: ReadonlyArray<string>;
  readonly citedByCount: number | null | undefined;
  readonly comment: string | null | undefined;
  readonly doi: string | null | undefined;
  readonly htmlUrl: string | null | undefined;
  readonly id: string;
  readonly journalRef: string | null | undefined;
  readonly landingUrl: string | null | undefined;
  readonly linkedAuthors: ReadonlyArray<{
    readonly displayName: string;
    readonly id: string;
    readonly orcid: string | null | undefined;
    readonly username: string;
    readonly " $fragmentSpreads": FragmentRefs<"EntityProfilePicFragment">;
  }>;
  readonly openalexId: string | null | undefined;
  readonly pdfLicense: string | null | undefined;
  readonly pdfUrl: string | null | undefined;
  readonly primaryCategory: string | null | undefined;
  readonly publishedAt: DateTime;
  readonly title: string;
  readonly updatedAt: DateTime | null | undefined;
  readonly venue: string | null | undefined;
  readonly version: number | null | undefined;
  readonly versions: ReadonlyArray<{
    readonly absUrl: string;
    readonly abstract: string;
    readonly authors: ReadonlyArray<string>;
    readonly comment: string | null | undefined;
    readonly htmlUrl: string;
    readonly number: number;
    readonly pdfUrl: string;
    readonly submittedAt: DateTime;
    readonly title: string;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"PaperAssessmentFragment" | "PaperBookmarkButtonFragment">;
  readonly " $fragmentType": "PaperDetailFragment";
};
export type PaperDetailFragment$key = {
  readonly " $data"?: PaperDetailFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaperDetailFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "abstract",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authors",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "comment",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "absUrl",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pdfUrl",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "htmlUrl",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaperDetailFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "arxivId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "openalexId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    (v1/*:: as any*/),
    (v2/*:: as any*/),
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryCategory",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "categories",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "announcedOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "doi",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "journalRef",
      "storageKey": null
    },
    (v4/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "venue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "citedByCount",
      "storageKey": null
    },
    (v5/*:: as any*/),
    (v6/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pdfLicense",
      "storageKey": null
    },
    (v7/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "landingUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "linkedAuthors",
      "plural": true,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "username",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "orcid",
          "storageKey": null
        },
        {
          "args": [
            {
              "kind": "Literal",
              "name": "thumbnail",
              "value": true
            }
          ],
          "kind": "FragmentSpread",
          "name": "EntityProfilePicFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PaperVersion",
      "kind": "LinkedField",
      "name": "versions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "number",
          "storageKey": null
        },
        (v1/*:: as any*/),
        (v2/*:: as any*/),
        (v3/*:: as any*/),
        (v4/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "submittedAt",
          "storageKey": null
        },
        (v5/*:: as any*/),
        (v6/*:: as any*/),
        (v7/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaperBookmarkButtonFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaperAssessmentFragment"
    }
  ],
  "type": "Paper",
  "abstractKey": null
};
})();

(node as any).hash = "040324c55fae05dc8289a67562b798a4";

export default node;
